import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "d-flex bg-white align-center justify-space-between pa-2" }
const _hoisted_2 = { class: "d-flex white align-center justify-space-between pa-2" }
const _hoisted_3 = { class: "d-flex bg-white align-center justify-space-between pa-2" }
const _hoisted_4 = { class: "d-flex bg-white align-center justify-space-between pa-2" }
const _hoisted_5 = { class: "d-flex bg-white align-center justify-space-between pa-2" }
const _hoisted_6 = { class: "d-flex bg-white align-center justify-space-between pa-2" }
const _hoisted_7 = { class: "d-flex bg-white align-center justify-space-between pa-2" }
const _hoisted_8 = { class: "d-flex bg-white align-center justify-space-between pa-2" }
const _hoisted_9 = {
  key: 0,
  class: "truncate"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "truncate"
}
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_range_slider = _resolveComponent("v-range-slider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, { class: "filter-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "px-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  sm: 12,
                  md: 4,
                  cols: "12",
                  class: "filter-col px-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, {
                      "align-center": "",
                      "justify-space-between": "",
                      class: "filter-header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_layout, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "primary",
                              class: "mr-3"
                            }, {
                              default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                _createTextVNode("fas fa-coins", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[47] || (_cache[47] = _createElementVNode("span", null, "Pot Size", -1))
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_v_btn, {
                          size: "small",
                          flat: "",
                          icon: "",
                          class: "reset-filter-btn",
                          onClick: _cache[0] || (_cache[0] = _withModifiers((e) => _ctx.resetFilter('potRange'), ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { small: "" }, {
                              default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                _createTextVNode("fas fa-times", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.potRangeIsDirty]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_range_slider, {
                      "model-value": _ctx.currentFilters.potRange || [],
                      max: _ctx.filters.potRange && _ctx.filters.potRange.max,
                      min: _ctx.filters.potRange && _ctx.filters.potRange.min,
                      "hide-details": "",
                      "track-size": 1,
                      "thumb-size": 12,
                      color: "primary",
                      density: "compact",
                      class: "align-center mt-2 px-3",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = (e) => _ctx.updatePotRange(e))
                    }, null, 8, ["model-value", "max", "min"]),
                    (_ctx.currentFilters.potRange)
                      ? (_openBlock(), _createBlock(_component_v_layout, {
                          key: 0,
                          class: "filter-value mx-5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.minmenu,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.minmenu) = $event)),
                              "content-class": "filter-edit-menus",
                              "close-on-content-click": false,
                              "close-on-click": false,
                              offset: "10",
                              location: "right"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.formatNumber(_ctx.currentFilters.potRange[0], '$0.0a')), 1),
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "10",
                                    class: "ml-1 mb-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                      _createTextVNode("fas fa-pen", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.currentFilters.potRange[0],
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentFilters.potRange[0]) = $event)),
                                    height: 14,
                                    flat: "",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.minmenu = false)),
                                    color: "secondary",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                      _createTextVNode("OK", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.maxmenu,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.maxmenu) = $event)),
                              "content-class": "filter-edit-menus",
                              "close-on-content-click": false,
                              "close-on-click": false,
                              offset: "10",
                              location: "bottom"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.formatNumber(_ctx.currentFilters.potRange[1], '$0.0a')), 1),
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "10",
                                    class: "ml-1 mb-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                      _createTextVNode("fas fa-pen", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.currentFilters.potRange[1],
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentFilters.potRange[1]) = $event)),
                                    height: 14,
                                    flat: "",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.maxmenu = false)),
                                    color: "secondary",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                      _createTextVNode("OK", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  sm: 12,
                  md: 4,
                  cols: "12",
                  class: "filter-col px-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, {
                      "align-center": "",
                      "justify-space-between": "",
                      class: "filter-header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_layout, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "primary",
                              class: "mr-3"
                            }, {
                              default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                                _createTextVNode("fas fa-coins", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[54] || (_cache[54] = _createElementVNode("span", null, "Score", -1))
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_v_btn, {
                          size: "small",
                          icon: "",
                          flat: "",
                          class: "reset-filter-btn",
                          onClick: _cache[8] || (_cache[8] = _withModifiers((e) => _ctx.resetFilter('scoreRange'), ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { small: "" }, {
                              default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                _createTextVNode("fas fa-times", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.scoreRangeIsDirty]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_range_slider, {
                      "model-value": _ctx.currentFilters.scoreRange || [],
                      max: _ctx.filters.scoreRange && Math.ceil(_ctx.filters.scoreRange.max),
                      min: _ctx.filters.scoreRange && Math.floor(_ctx.filters.scoreRange.min),
                      "hide-details": "",
                      step: 1,
                      "track-size": 1,
                      "thumb-size": 12,
                      color: "primary",
                      density: "compact",
                      class: "align-center mt-2 px-3",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = 
                (e) => {
                  _ctx.updateScoreRange(e);
                }
              )
                    }, null, 8, ["model-value", "max", "min"]),
                    (_ctx.currentFilters.scoreRange)
                      ? (_openBlock(), _createBlock(_component_v_layout, {
                          key: 0,
                          class: "filter-value mx-5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.minScoreMenu,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.minScoreMenu) = $event)),
                              "content-class": "filter-edit-menus",
                              "close-on-content-click": false,
                              "close-on-click": false,
                              offset: "10",
                              location: "bottom"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.currentFilters.scoreRange[0]), 1),
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "10",
                                    class: "ml-1 mb-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                      _createTextVNode("fas fa-pen", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.currentFilters.scoreRange[0],
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentFilters.scoreRange[0]) = $event)),
                                    height: 14,
                                    flat: "",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.minScoreMenu = false)),
                                    color: "secondary",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                      _createTextVNode("OK", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.maxScoreMenu,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.maxScoreMenu) = $event)),
                              "content-class": "filter-edit-menus",
                              "close-on-content-click": false,
                              "close-on-click": false,
                              offset: "10",
                              location: "bottom"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.currentFilters.scoreRange[1]), 1),
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "10",
                                    class: "ml-1 mb-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                      _createTextVNode("fas fa-pen", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.currentFilters.scoreRange[1],
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentFilters.scoreRange[1]) = $event)),
                                    height: 14,
                                    flat: "",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.maxScoreMenu = false)),
                                    color: "secondary",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                                      _createTextVNode("OK", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  sm: 6,
                  md: 4,
                  cols: "12",
                  class: "filter-col px-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, {
                      "align-center": "",
                      "justify-space-between": "",
                      class: "filter-header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_layout, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "primary",
                              class: "mr-3"
                            }, {
                              default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                                _createTextVNode("fas fa-percentage", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[61] || (_cache[61] = _createElementVNode("span", null, "IRR", -1))
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_v_btn, {
                          size: "small",
                          flat: "",
                          icon: "",
                          class: "reset-filter-btn",
                          onClick: _cache[16] || (_cache[16] = _withModifiers((e) => _ctx.resetFilter('irrRange'), ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { small: "" }, {
                              default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                                _createTextVNode("fas fa-times", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.irrRangeIsDirty]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_range_slider, {
                      "model-value": _ctx.currentFilters.irrRange || [],
                      max: _ctx.filters.irrRange && _ctx.filters.irrRange.max,
                      min: _ctx.filters.irrRange && _ctx.filters.irrRange.min,
                      "hide-details": "",
                      "track-size": 1,
                      "thumb-size": 12,
                      color: "primary",
                      density: "compact",
                      class: "align-center mt-2 px-3",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = 
                (e) => {
                  _ctx.updateIrrRange(e);
                }
              )
                    }, null, 8, ["model-value", "max", "min"]),
                    (_ctx.currentFilters.irrRange)
                      ? (_openBlock(), _createBlock(_component_v_layout, {
                          key: 0,
                          class: "filter-value mx-5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.minIrrmenu,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.minIrrmenu) = $event)),
                              "content-class": "filter-edit-menus",
                              "close-on-content-click": false,
                              "close-on-click": false,
                              offset: "10",
                              location: "bottom"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.formatNumber(_ctx.currentFilters.irrRange[0], '0.0a')) + "%", 1),
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "10",
                                    class: "ml-1 mb-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                                      _createTextVNode("fas fa-pen", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.currentFilters.irrRange[0],
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.currentFilters.irrRange[0]) = $event)),
                                    height: 14,
                                    flat: "",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.minIrrmenu = false)),
                                    color: "secondary",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                                      _createTextVNode("OK", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.maxIrrmenu,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.maxIrrmenu) = $event)),
                              "content-class": "filter-edit-menus",
                              "close-on-content-click": false,
                              "close-on-click": false,
                              offset: "10",
                              location: "bottom"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.formatNumber(_ctx.currentFilters.irrRange[1], '0.0a')) + "%", 1),
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "10",
                                    class: "ml-1 mb-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                                      _createTextVNode("fas fa-pen", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.currentFilters.irrRange[1],
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.currentFilters.irrRange[1]) = $event)),
                                    height: 14,
                                    flat: "",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.maxIrrmenu = false)),
                                    color: "secondary",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                                      _createTextVNode("OK", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  sm: 6,
                  md: 4,
                  cols: "12",
                  class: "filter-col px-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, {
                      "align-center": "",
                      "justify-space-between": "",
                      class: "filter-header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_layout, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "primary",
                              class: "mr-3"
                            }, {
                              default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                                _createTextVNode("fas fa-chart-line", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[68] || (_cache[68] = _createElementVNode("span", null, "Benchmark IRR", -1))
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_v_btn, {
                          size: "small",
                          flat: "",
                          icon: "",
                          class: "reset-filter-btn",
                          onClick: _cache[24] || (_cache[24] = _withModifiers((e) => _ctx.resetFilter('birrRange'), ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { small: "" }, {
                              default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                                _createTextVNode("fas fa-times", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.birrRangeIsDirty]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_range_slider, {
                      "model-value": _ctx.currentFilters.birrRange || [],
                      max: _ctx.filters.birrRange && _ctx.filters.birrRange.max,
                      min: _ctx.filters.birrRange && _ctx.filters.birrRange.min,
                      "hide-details": "",
                      "track-size": 1,
                      "thumb-size": 12,
                      color: "primary",
                      density: "compact",
                      class: "align-center mt-2 px-3",
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = 
                (e) => {
                  _ctx.updateBirrRange(e);
                }
              )
                    }, null, 8, ["model-value", "max", "min"]),
                    (_ctx.currentFilters.birrRange)
                      ? (_openBlock(), _createBlock(_component_v_layout, {
                          key: 0,
                          class: "filter-value mx-5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.minBirrmenu,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.minBirrmenu) = $event)),
                              "content-class": "filter-edit-menus",
                              "close-on-content-click": false,
                              "close-on-click": false,
                              offset: "10",
                              location: "bottom"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.formatNumber(_ctx.currentFilters.birrRange[0], '0.0a')) + "%", 1),
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "10",
                                    class: "ml-1 mb-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                                      _createTextVNode("fas fa-pen", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.currentFilters.birrRange[0],
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.currentFilters.birrRange[0]) = $event)),
                                    height: 14,
                                    flat: "",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.minBirrmenu = false)),
                                    color: "secondary",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                                      _createTextVNode("OK", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.maxBirrmenu,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.maxBirrmenu) = $event)),
                              "content-class": "filter-edit-menus",
                              "close-on-content-click": false,
                              "close-on-click": false,
                              offset: "10",
                              location: "bottom"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.formatNumber(_ctx.currentFilters.birrRange[1], '0.0a')) + "%", 1),
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    size: "10",
                                    class: "ml-1 mb-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                                      _createTextVNode("fas fa-pen", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 16)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.currentFilters.birrRange[1],
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.currentFilters.birrRange[1]) = $event)),
                                    height: 14,
                                    flat: "",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.maxBirrmenu = false)),
                                    color: "secondary",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                                      _createTextVNode("OK", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.showStringFilters && _ctx.filters.dataPoints)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      xs: 6,
                      md: 4,
                      class: "px-7 my-auto providerFilter"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_layout, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_autocomplete, {
                              "model-value": _ctx.currentFilters.stringVals,
                              items: _ctx.filters.stringFilterDataPoints,
                              "hide-details": true,
                              chips: "",
                              "closable-chips": "",
                              variant: "underlined",
                              clearable: true,
                              "allow-overflow": false,
                              color: "primary",
                              label: "Select String Values",
                              multiple: "",
                              "return-object": "",
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = 
                  (e) => {
                    _ctx.updateStringFilters(e);
                  }
                )
                            }, {
                              chip: _withCtx(({ props, item }) => [
                                _createVNode(_component_v_chip, _mergeProps(props, {
                                  close: "",
                                  class: "filter-chips mx-1 my-1",
                                  size: "default",
                                  "close-icon": "fa fa-times-circle",
                                  "onClick:close": ($event: any) => (_ctx.removeProvider(item.raw))
                                }), {
                                  default: _withCtx(() => [
                                    (item.raw?.val.length > 15)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.raw?.val), 1))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.raw?.val), 1))
                                  ]),
                                  _: 2
                                }, 1040, ["onClick:close"])
                              ]),
                              item: _withCtx(({ item, props }) => [
                                ('divider' in item.raw)
                                  ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                                  : ('header' in item.raw)
                                    ? (_openBlock(), _createBlock(_component_v_list_subheader, {
                                        key: 1,
                                        title: item.raw.header
                                      }, null, 8, ["title"]))
                                    : (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({ key: 2 }, props, {
                                        title: item.raw?.val,
                                        value: item.raw?.val
                                      }), null, 16, ["title", "value"]))
                              ]),
                              _: 1
                            }, 8, ["model-value", "items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { align: "end" }, {
              default: _withCtx(() => [
                (_ctx.dateFilters)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      xs: 6,
                      md: 4,
                      "align-self": "end",
                      class: "filter-col"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_layout, {
                          "align-center": "",
                          "justify-space-between": "",
                          class: "filter-header"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_layout, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  color: "primary",
                                  class: "mr-3"
                                }, {
                                  default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                    _createTextVNode("fas fa-calendar-day", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[75] || (_cache[75] = _createElementVNode("span", null, "Contribution Date", -1))
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_v_btn, {
                              icon: "",
                              class: "reset-filter-btn",
                              size: "small",
                              flat: "",
                              onClick: _cache[33] || (_cache[33] = _withModifiers((e) => _ctx.resetFilter('startDate') && _ctx.resetFilter('endDate'), ["stop"]))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                  default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                                    _createTextVNode("fas fa-times", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.startDateIsDirty || _ctx.endDateIsDirty]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_layout, { class: "px-3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.startDatePicker,
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.startDatePicker) = $event)),
                              "close-on-content-click": false,
                              "hide-details": true,
                              transition: "scale-transition",
                              "min-width": "100px"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_layout, { "d-flex": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, _mergeProps({
                                      modelValue: _ctx.longStartDate,
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.longStartDate) = $event)),
                                      variant: "underlined",
                                      color: "primary",
                                      label: "Start Date",
                                      readonly: "",
                                      "hide-details": ""
                                    }, props), null, 16, ["modelValue"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_date_picker, {
                                  id: "startDatepicker",
                                  scrollable: "",
                                  "prev-icon": "fa fa-chevron-left",
                                  "next-icon": "fa fa-chevron-right",
                                  "mode-icon": "fa fa-chevron-down",
                                  color: "primary",
                                  "model-value": _ctx.currentFilters.startDate,
                                  "onClick:cancel": _cache[35] || (_cache[35] = ($event: any) => (_ctx.startDatePicker = false)),
                                  "onClick:save": _cache[36] || (_cache[36] = ($event: any) => (_ctx.startDatePicker = false)),
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = 
                    (e) => {
                      _ctx.updateStartDate(e);
                    }
                  )
                                }, {
                                  header: _withCtx(({ header }) => [...(_cache[77] || (_cache[77] = []))]),
                                  _: 1
                                }, 8, ["model-value"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_menu, {
                              modelValue: _ctx.endDatePicker,
                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.endDatePicker) = $event)),
                              "close-on-content-click": false,
                              "hide-details": true,
                              transition: "scale-transition",
                              "offset-y": "",
                              "min-width": "100px"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_layout, {
                                  "d-flex": "",
                                  "pl-3": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, _mergeProps({
                                      modelValue: _ctx.longEndDate,
                                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.longEndDate) = $event)),
                                      class: "ml-2",
                                      variant: "underlined",
                                      color: "primary",
                                      "hide-details": "",
                                      label: "End Date",
                                      readonly: ""
                                    }, props), null, 16, ["modelValue"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_date_picker, {
                                  id: "endDatepicker",
                                  scrollable: "",
                                  "prev-icon": "fa fa-chevron-left",
                                  "next-icon": "fa fa-chevron-right",
                                  "mode-icon": "fa fa-chevron-down",
                                  color: "primary",
                                  "model-value": _ctx.currentFilters.endDate,
                                  "onClick:cancel": _cache[40] || (_cache[40] = ($event: any) => (_ctx.endDatePicker = false)),
                                  "onClick:save": _cache[41] || (_cache[41] = ($event: any) => (_ctx.endDatePicker = false)),
                                  "onUpdate:modelValue": _cache[42] || (_cache[42] = 
                    (e) => {
                      _ctx.updateEndDate(e);
                    }
                  )
                                }, {
                                  header: _withCtx(({ header }) => [...(_cache[78] || (_cache[78] = []))]),
                                  _: 1
                                }, 8, ["model-value"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.showProviderFilters)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "12",
                      xs: 6,
                      md: 4,
                      class: "pb-0 px-7 providerFilter"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.providerFilter)
                          ? (_openBlock(), _createBlock(_component_v_layout, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_autocomplete, {
                                  "model-value": _ctx.currentFilters.providers,
                                  items: _ctx.filters.providers,
                                  "hide-details": true,
                                  chips: "",
                                  "closable-chips": "",
                                  clearable: true,
                                  "allow-overflow": false,
                                  color: "primary",
                                  label: "Select Providers",
                                  "item-title": "name",
                                  "item-value": "id",
                                  variant: "underlined",
                                  multiple: "",
                                  "onUpdate:modelValue": _cache[44] || (_cache[44] = 
                  (e) => {
                    _ctx.updateProviders(e);
                  }
                )
                                }, {
                                  chip: _withCtx(({ props, item }) => [
                                    _createVNode(_component_v_chip, _mergeProps(props, {
                                      close: "",
                                      class: "filter-chips mx-1 my-1",
                                      size: "default",
                                      "close-icon": "fa fa-times-circle",
                                      "onClick:close": ($event: any) => (_ctx.removeProvider(item.raw))
                                    }), {
                                      default: _withCtx(() => [
                                        (item.raw?.name.length > 15)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(item.raw?.name), 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.raw?.name), 1))
                                      ]),
                                      _: 2
                                    }, 1040, ["onClick:close"])
                                  ]),
                                  item: _withCtx(({ props, item }) => [
                                    _createVNode(_component_v_list_item, _mergeProps(props, {
                                      title: item.raw?.name
                                    }), null, 16, ["title"])
                                  ]),
                                  _: 1
                                }, 8, ["model-value", "items"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { align: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  xs: 12,
                  class: "filter-col mb-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, {
                      "align-end": "",
                      class: "d-flex justify-end mr-5"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_v_btn, {
                          variant: "text",
                          depressed: "",
                          light: "",
                          onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.resetFilters()))
                        }, {
                          default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                            _createTextVNode("Reset", -1)
                          ]))]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.filtersCanBeReset]
                        ]),
                        _createVNode(_component_v_btn, {
                          onClick: _withModifiers(_ctx.applyFilter, ["stop"]),
                          color: "success",
                          class: "ml-3",
                          disabled: !_ctx.filtersAreDirty
                        }, {
                          default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                            _createTextVNode("Apply", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}